import { useState } from "react";
import {
  Home,
  Map,
  Calculate,
  ReceiptLong,
  Report,
  Logout,
  SettingsAccessibility,
  Pause,
  PlayArrow,
  ListAlt,
  List,
  FormatListNumbered,
} from "@mui/icons-material";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import RootLayout from "../RootLayout";

export default function EICLayout() {
  const theme = useTheme(); // Move useTheme inside the component
  const [open, setOpen] = useState(true);
  const [showProfile, setShowProfile] = useState(true);
  
  const ExecMenuItems = [
    { key: "home", to: "/", title: "Home", iconClass: <Home /> },
    { key: "placeOnHold", to: "/placeOnHold", title: "Reserve/Release Parcel", iconClass: <Pause /> },
    {
      key: "GROUP",
      iconClass: (
        <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
          <ListAlt />
        </Box>
      ),
      title: "List",
      detail: [
        {
          key: "agreementList",
          to: "/agreementList",
          title: "Agreements",
          iconClass: (
            <Box>
              <List />
            </Box>
          ),
        },
        {
          key: "investorList",
          to: "/investorList",
          title: "Investors",
          iconClass: (
            <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
              <List />
            </Box>
          ),
        },
        {
          key: "propertyList",
          to: "/parcelList",
          title: "Parcels",
          iconClass: (
            <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
              <FormatListNumbered />
            </Box>
          ),
        },
      ],
    },
    { key: "viewMapByCategory", to: "/viewMapByCategory", title: "Map By Category", iconClass: <Map /> },
    {
      key: "GROUP",
      iconClass: <Report />,
      title: "Report",
      detail: [
        {
          key: "GROUP",
          iconClass: <Report />,
          title: "Finance",
          detail: [
            {
              key: "Revenue",
              to: "/financeSummary",
              title: "Revenue",
              iconClass: <Report />,
            },
            {
              key: "arrear",
              to: "/arrear",
              title: "Arrear",
              iconClass: <Report />,
            },
            {
              key: "summary",
              to: "/financialReports",
              title: "Summary",
              iconClass: <Report />,
            },
          ],
        },
        {
          key: "GROUP",
          iconClass: <Report />,
          title: "L & I report",
          detail: [
            {
              key: "masterplan",
              to: "/landInfraReports",
              title: "Master plan",
              iconClass: <Report />,
            },
            {
              key: "designconstruction",
              to: "/designandconstruction",
              title: "Design and Construction",
              iconClass: <Report />,
            },
          ],
        },
        {
          key: "GROUP",
          iconClass: <Report />,
          title: "Operation",
          detail: [
            {
              key: "investors",
              to: "/inverstors",
              title: "Investors",
              iconClass: <Report />,
            },
            {
              key: "employment",
              to: "/employment",
              title: "Employment",
              iconClass: <Report />,
            },
            {
              key: "trade",
              to: "/TradeReports",
              title: "Trade",
              iconClass: <Report />,
            },
          ],
        },
        {
          key: "promotion",
          to: "/promReport",
          title: "Promotion",
          iconClass: <Report />,
        },
      ],
    },
    { key: "myPreference", to: "/myPreference", title: "Preferences", iconClass: <SettingsAccessibility /> },
    { key: "logout", to: "/logout", title: "Logout", iconClass: <Logout /> },
  ];

  return (
    <RootLayout
      department="Executives"
      open={open}
      setOpen={setOpen}
      showProfile={showProfile}
      setShowProfile={setShowProfile}
      menuList={ExecMenuItems}
    />
  );
}